import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  initials,
  name,
  location,
  text
}: TestimonialProps) => <div className="bg-brand-card p-4 md:p-5 rounded-xl border border-white/10 flex flex-col h-full hover:border-brand-accent/30 transition-colors" data-id="element-267">
    <div className="flex items-center mb-3" data-id="element-268">
      <div className="w-10 h-10 bg-brand-accent text-white rounded-full flex items-center justify-center font-bold text-lg mr-3 shrink-0" data-id="element-269">
        {initials}
      </div>
      <div data-id="element-270">
        <div className="flex text-brand-accent mb-0.5" data-id="element-271">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-272" />)}
        </div>
        <p className="font-bold text-white text-sm leading-tight" data-id="element-273">{name}</p>
        <p className="text-[10px] md:text-xs text-gray-500" data-id="element-274">📍 {location}</p>
      </div>
    </div>
    <p className="text-gray-400 text-sm italic flex-grow leading-relaxed" data-id="element-275">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection2() {
  const testimonials = [{
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza | Escuela Técnica Agropecuaria',
    text: 'Por fin tengo ejemplos reales para explicar economía. Antes todo era urbano. Ahora mis alumnos entienden costos y producción porque lo ven en su propio contexto.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires | Orientación Agro y Ambiente',
    text: 'El tomo de costos y producción me cambió las clases. Dejé de improvisar y ahora explico con casos reales del campo.'
  }, {
    initials: 'SC',
    name: 'Sofía C.',
    location: 'Santiago del Estero | Escuela Rural',
    text: 'Mis alumnos nunca entendían la economía. Con este material empezaron a relacionarlo con su realidad. Fue un antes y un después.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Neuquén | Docente de Producción Agropecuaria',
    text: 'Los proyectos productivos listos me ahorraron semanas de trabajo. Ya no invento actividades, ya tengo todo armado.'
  }, {
    initials: 'VD',
    name: 'Valeria D.',
    location: 'Córdoba | Escuela Técnica Agropecuaria',
    text: 'Las evaluaciones con rúbricas me cambiaron la vida. Antes corregía sin criterios claros y perdía horas. Ahora tengo todo organizado y mis alumnos saben exactamente qué se les evalúa.'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-276">
      <div className="max-w-5xl mx-auto" data-id="element-277">
        <h2 className="text-2xl md:text-3xl font-black text-center mb-8 text-white" data-id="element-278">
          ❤️ MÁS DOCENTES QUE YA LO TIENEN
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-279">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-280" />)}
        </div>
      </div>
    </section>;
}